import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { NestResponsesProvider } from '../../../shared/nestjs/nest-responses';
import { SfRequestInboxNestApi } from "../../../shared/nestjs/gd-only/services/sf-request-inbox.api";
@Injectable()
export class RequestInboxBloc {

	private subscriptions: Array<Subscription> = [];
	constructor(
		public nestResponsesProvider: NestResponsesProvider,
		public sfRequestInboxNestApi: SfRequestInboxNestApi,
	) {

	}

	dispose() {
		this.subscriptions.forEach(subs => subs.unsubscribe());
	}

	closeRequest(payload: { requestNo: string[] }) {
		return new Promise((resolve, reject) => {
			this.subscriptions.push(
				this.sfRequestInboxNestApi.closeRequest(payload)
					.subscribe(result => {
						resolve(result)
					}, error => {
						reject(error)
					})
			)
		})
	}

}



// WEBPACK FOOTER //
// ./src/bloc/feature/request/request-inbox.bloc.ts